import { createSelector } from "reselect";

export const getReport = ({ PPEInspection_reducer }) => {
    return PPEInspection_reducer.report;
};

export const selectCurrentReport = createSelector(
    [getReport],
    report => {
        if (report === false) {
            return false;
        }
        return report;
    }
);
